import React from 'react';
import { projects } from '../data/content';

export default function Projects() {
  return (
    <section className="projects" id="projects">
      <p className="section-title">Projects & Leadership</p>
      <h2>Live applications & community</h2>
      <div className="projects__grid">
        {projects.map((project) => (
          <article key={project.title} className="projects__card">
            <h3>{project.title}</h3>
            <p className="projects__desc">{project.description}</p>
            {project.links && project.links.length > 0 && (
              <div className="projects__links">
                {project.links.map((link, i) => (
                  <span key={link.url}>
                    {i > 0 && <span className="projects__sep"> · </span>}
                    <a href={link.url} target="_blank" rel="noopener noreferrer" className="projects__link">
                      {link.label}
                    </a>
                  </span>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
